module.exports = __webpack_public_path__ + "static/homepage-hero-a3e7a9a09db904560b3d1702494062f2.mp4";